/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import Vue from 'vue';
import cacheAxios from '../../util/cacheAxios';

const hrNewsAxios = axios.create();
const cache = new Map();
cacheAxios(hrNewsAxios, cache);
hrNewsAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims#/news/hr';
      }, 500);
    }
  });

const seriesDefault = {
  name: 'HR Sentiments',
  type: 'map',
  mapType: 'world',
  // aspectScale: 0.85,
  roam: true,
  selectedMode: 'single',
  label: {
    normal: {
      show: false,
    },
    emphasis: {
      show: false,
    },
  },
  itemStyle: {
    normal: {
      borderColor: 'rgba(0, 0, 0, 0.8)',
      borderWidth: 0,
      areaColor: '#e2e2e2',
      // areaColor: '#fff',
    },
    emphasis: {
      borderColor: '#a0bfff',
      borderWidth: 2,
      areaColor: '#200fff',
    },
  },
  data: [],
};

export default {
  state: {
    sortBy: 'sentiment',
    hrCategories: [], // y
    hrChartLoading: true, // y
    hrSearchText: '',
    hrNewsLoading: false,
    hrStartDate: '',
    hrEndDate: '',
    hrCountrySelected: '',
    negativeHrNews: [],
    positiveHrNews: [],
    hrStartDateFilter: '',
    hrEndDateFilter: '',
    hrCategoryFilter: {},
    hrChartOptions: {
      backgroundColor: '#fff',
      title: {
        text: 'HR Sentiments',
        subtext: 'Worldwide',
        left: 'center',
        top: 'top',
        subtextStyle: {
          fontSize: 16,
          color: '#333',
        },
        textStyle: {
          color: '#333',
        },
      },
      tooltip: {
        trigger: 'item',
      },
      visualMap: {
        type: 'continuous',
        min: -100,
        max: 100,
        text: ['Positive', 'Negative'],
        realtime: true,
        calculable: false,
        dimension: 0,
        inRange: {
          color: ['#f00', '#c00', '#900', '#aaa', '#090', '#0c0', '#0f0'],
        },
        textStyle: {
          color: '#111',
        },
      },
      series: [
        {
          name: 'HR Sentiments',
          type: 'map',
          mapType: 'world',
          // zoom: 2.4,
          // aspectScale: 0.85,
          // center: [101, 7.5],
          roam: true,
          selectedMode: 'single',
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(0, 0, 0, 0.8)',
              borderWidth: 0,
              areaColor: '#e2e2e2',
              // areaColor: '#fff',
            },
            emphasis: {
              borderColor: '#a0bfff',
              borderWidth: 2,
              areaColor: '#200fff',
            },
          },
          data: [],
          },
        ],
    },
  },
  mutations: {
    setSortBy(state, sort) {
      state.sortBy = sort;
    },
    setHrData(state, data) {
      const mappedData = data.map((c) => {
        if (c.name === state.hrCountrySelected) {
          c.selected = true;
        } else {
          c.selected = false;
        }
        return c;
      });
      const series0 = { ...seriesDefault,
        data: mappedData,
      };
      state.hrChartOptions = {
        ...state.hrChartOptions,
        series: [series0],
      };
    },
    setHrSearchText(state, text) {
      state.hrSearchText = text;
    },
    setHrCategories(state, categories) {
      state.hrCategories = categories;
    },
    setHrNewsLoading(state, loading) {
      state.hrNewsLoading = loading;
    },
    setPositiveHrNews(state, news) {
      state.positiveHrNews = news;
    },
    setNegativeHrNews(state, news) {
      state.negativeHrNews = news;
    },
    appendPositiveHrNews(state, news) {
      state.positiveHrNews = [...state.positiveHrNews, ...news];
    },
    appendNegativeHrNews(state, news) {
      state.negativeHrNews = [...state.negativeHrNews, ...news];
    },
    setHrCountrySelected(state, country) {
      state.hrCountrySelected = country;
      const mappedData = state.hrChartOptions.series[0].data.map((c) => {
        if (c.name === state.hrCountrySelected) {
          c.selected = true;
        } else {
          c.selected = false;
        }
        return c;
      });
      const series0 = { ...seriesDefault,
        data: mappedData,
      };
      const cty = country === '' ? 'Worldwide' : country;
      const title = {
        ...state.hrChartOptions.title,
        subtext: cty,
      };
      state.hrChartOptions = {
        ...state.hrChartOptions,
        series: [series0],
        title,
      };
    },
    addHrCategoryFilter(state, category) {
      Vue.set(state.hrCategoryFilter, category, true);
    },
    removeHrCategoryFilter(state, category) {
      Vue.set(state.hrCategoryFilter, category, false);
    },
    setHrStartDate(state, date) {
      state.hrStartDate = date;
    },
    setHrEndDate(state, date) {
      state.hrEndDate = date;
    },
    setHrChartLoading(state, loading) {
      state.hrChartLoading = loading;
    },
    setHrStartDateFilter(state, startDate) {
      state.hrStartDateFilter = startDate.toISOString()
        .slice(0, 10);
    },
    setHrEndDateFilter(state, endDate) {
      state.hrEndDateFilter = endDate.toISOString()
        .slice(0, 10);
    },
  },
  actions: {
    initHrCategory({
      commit,
    }) {
      hrNewsAxios.get('/aims/api/hr/category')
        .then((res) => {
          if (res.data) {
            const categories = res.data.categories.map((cat) => {
              if (cat === 'Legislation') {
                return {
                  label: cat,
                  id: cat,
                  children: res.data.legislationArticleTypes.map(art => ({
                    label: art || 'Others',
                    underLegislation: true,
                    id: `Legislation|${art || 'Others'}`,
                  })),
                };
              }
              return {
                label: cat,
                id: cat,
              };
            });
            commit('setHrCategories', categories);
          }
        });
    },
    changeSortBy({
      state, commit, dispatch,
    }, sortBy) {
      if (sortBy === state.sortBy) {
        return;
      }
      commit('setSortBy', sortBy);
      dispatch('getHrNews');
    },
    getHrNews({
      commit,
      dispatch,
    }) {
      commit('setPositiveHrNews', []);
      commit('setNegativeHrNews', []);
      dispatch('getMorePositiveHrNews');
      dispatch('getMoreNegativeHrNews');
    },
    getMorePositiveHrNews({
      state,
      commit,
    }) {
      commit('setHrNewsLoading', true);
      if (state.positiveHrNews.length !== 0 && state.positiveHrNews.length % 20 !== 0) {
        commit('setHrNewsLoading', false);
        return;
      }
      const categories = Object.keys(state.hrCategoryFilter)
        .filter(k => state.hrCategoryFilter[k]);
      const postPosBody = {
        start: state.hrStartDateFilter,
        end: state.hrEndDateFilter,
        categories: categories.sort(),
        country: state.hrCountrySelected,
        sentiment_type: 'positive',
        sortBy: state.sortBy,
        searchText: state.hrSearchText.trim(),
        fromIndex: state.positiveHrNews.length,
      };
      hrNewsAxios.post('/aims/api/hr/newsByDateAndCategories', postPosBody, {
          cache: true,
          cacheKey: JSON.stringify(postPosBody),
        })
        .then((res) => {
          if (!res.data) {
            commit('setHrNewsLoading', false);
            return;
          }
          const data = res.data.map((news) => {
            const published = new Date(news.published);
            news.published = published.toISOString()
              .slice(0, 10);
            return news;
          });
          data.sort((a, b) => {
            if (a.published < b.published) {
              return 1;
            } else if (a.published > b.published) {
              return -1;
            }
            return 0;
          });
          commit('appendPositiveHrNews', data);
          commit('setHrNewsLoading', false);
        });
    },
    getMoreNegativeHrNews({
      state,
      commit,
    }) {
      commit('setHrNewsLoading', true);
      if (state.negativeHrNews.length !== 0 && state.negativeHrNews.length % 20 !== 0) {
        commit('setHrNewsLoading', false);
        return;
      }
      const categories = Object.keys(state.hrCategoryFilter)
        .filter(k => state.hrCategoryFilter[k]);
      const postNegBody = {
        start: state.hrStartDateFilter,
        end: state.hrEndDateFilter,
        categories: categories.sort(),
        country: state.hrCountrySelected,
        sentiment_type: 'negative',
        sortBy: state.sortBy,
        searchText: state.hrSearchText.trim(),
        fromIndex: state.negativeHrNews.length,
      };
      hrNewsAxios.post('/aims/api/hr/newsByDateAndCategories', postNegBody, {
          cache: true,
          cacheKey: JSON.stringify(postNegBody),
        })
        .then((res) => {
          if (!res.data) {
            commit('setHrNewsLoading', false);
            return;
          }
          const data = res.data.map((news) => {
            const published = new Date(news.published);
            news.published = published.toISOString()
              .slice(0, 10);
            return news;
          });
          data.sort((a, b) => {
            if (a.published < b.published) {
              return 1;
            } else if (a.published > b.published) {
              return -1;
            }
            return 0;
          });
          commit('appendNegativeHrNews', data);
          commit('setHrNewsLoading', false);
        });
    },
    filterHrByDate({
      commit,
      getters,
      dispatch,
    }, dateSelection) {
      commit('setHrStartDateFilter', dateSelection[0]);
      commit('setHrEndDateFilter', dateSelection[1]);
      dispatch('getScoreByDateAndCategories');
    },
    getScoreByDateAndCategories({
      state,
      commit,
    }) {
      const categories = Object.keys(state.hrCategoryFilter)
        .filter(k => state.hrCategoryFilter[k]);
      const postBody = {
        start: state.hrStartDateFilter,
        end: state.hrEndDateFilter,
        categories: categories.sort(),
      };
      hrNewsAxios.post(
          '/aims/api/hr/scoreByDateAndCategories', postBody, {
            cache: true,
            cacheKey: JSON.stringify(postBody),
          },
        )
        .then((res) => {
          commit('setHrData', res.data);
          commit('setHrChartLoading', false);
        });
    },
  },
  getters: {

  },
};



// WEBPACK FOOTER //
// ./src/store/modules/hrNewsModule.js